<template>
  <div  class="OrderIndex">
      <div class="order-detail">
        <div class="order-detail-title">订单详情</div>
        <div class="order-detail-content">订单号：{{orderDetail.oid}}</div>
        <!--标注信息旗-->
        <OrderFlagMarker :orderDetail="orderDetail"  @getorderDetail="getorderDetail()"></OrderFlagMarker>
        <!--询价状态-->
        <div class="order-detail-end" v-if="storeInfo.type==2&&$GFUN.isInArray([4],orderDetail.status)">
          <span class="red mr-2">{{clockCount }}</span>
          <el-button @click="showConfirmPanel=true" type="primary" size="small"  style="margin: 0 auto; display: block;">结束询价</el-button>
        </div>
      </div>
      <!--订单状态-->
      <OrderState :orderDetail="orderDetail"></OrderState>
      <!--订单团队信息-->
      <OrderTeam :orderDetail="orderDetail"></OrderTeam>
      <!---------------------------------订单询价状态--------------------------------->
      <div class="housing" v-if="orderDetail.deal_time==0">
          <!--用房信息-->
          <OrderHousing :orderDetail="orderDetail" :quotationList="quotationList"></OrderHousing>
          <!--采购商·酒店报价列表-->
          <OrderQuotation :orderDetail="orderDetail" :quotationList="quotationList" v-if="$GFUN.isInArray([2,99],storeInfo.type)"></OrderQuotation>
        <!--销售·酒店报价列表-->
        <OrderHotelQuotation 
         v-if="storeInfo.type==3"
         :orderDetail="orderDetail" 
         :quotationList="quotationList" 
         :match_hotel_list="match_hotel_list" 
         :match_store_id="match_store_id" 
          @quotationShow="(res) => onquotationShow(res)"
          @refuseShow="(res) => onrefuseShow(res)"
          @getorderDetail="getorderDetail()"
        >
        </OrderHotelQuotation>
      </div>
      <!---------------------------------订单已成交状态--------------------------------->
      <div v-else class="check mt-4">
        <!--酒店信息-->
        <OrderTeam :orderDetail="orderDetail" :type="3"></OrderTeam>
        <!--用房信息-->
        <OrderHousing :orderDetail="orderDetail" :quotationList="quotationList"></OrderHousing>
      </div>
      <!--核房人、支付人、入住名单-->
      <!-- <OrderCheckList :orderDetail="orderDetail"></OrderCheckList> -->
      <!--成交订单状态按钮-->
      <Orderbutton 
        :orderDetail="orderDetail" 
        v-if="$GFUN.isInArray([7,8,9],orderDetail.status)" 
        @showConfirmPanel="showConfirmPanel=true" 
        @collectionShow="collectionShow=true"
        @getorderDetail="getorderDetail()"
        @viewChanges="onViewChanges"
        ></Orderbutton>
       <!---------------------------------功能弹窗--------------------------------->
      <!--酒店报价弹窗-->
      <OrderHotelFill  
        ref="OrderHotelFill" 
        :orderDetail="orderDetail" 
        :quotationShow="quotationShow" 
        :match_hotel_list="match_hotel_list"  
        @onShow="quotationShow=false" 
        @getorderDetail="getorderDetail()"
      ></OrderHotelFill>
      <!--酒店接不了弹窗-->
      <OrderHoteRefuse ref="OrderHoteRefuse" :refuseShow="refuseShow"  :match_hotel_list="match_hotel_list" @onShow="refuseShow=false" @getorderDetail="getorderDetail();refuseShow=false"> </OrderHoteRefuse>
      <!--订单取消弹窗-->
      <verify-number url="/pc/User/GetSafeCode"  :number="orderDetail.send_mobile" v-if="showShopCar" @submitOrder="submitOrder" @switch="showShopCar=!showShopCar"> </verify-number>
        <el-dialog  :visible.sync="showConfirmPanel" width="340px" center id="loadConfirm" top="32vh" :close-on-click-modal="false" :show-close="false">
            <div class="mb-2">{{ orderDetail.deal_time>0?'确认取消订单吗？':'确认结束询价吗？' }}</div>
            <el-select v-model="arrow_down" placeholder="请选择取消原因" class="selects">
                <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        <div slot="footer" class="cancel">
            <el-button size="small" @click="showConfirmPanel = false;arrow_down=''">取消</el-button>
            <el-button size="small" type="primary" @click="number">确认</el-button>
        </div>
      </el-dialog>
      <!--代收款弹窗-->
      <OrderCollectionOnDehalf :collectionShow="collectionShow" :orderDetail="orderDetail" :quotationList="quotationList" ref="collectionOnDehalf"  @onShow="collectionShow=false" />
      <!--查看修改弹窗-->
      <OrderConfirmPanel  ref="confirmPanel" :confirmPanelShow="confirmPanelShow" :orderDetail="orderDetail"  @onShow="confirmPanelShow=false" @getorderDetail="getorderDetail();confirmPanelShow=false" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions,mapMutations } from 'vuex'
import OrderState from './Components/OrderState' //订单状态
import OrderTeam from './Components/OrderTeam' //订单团队信息
import OrderHousing from './Components/OrderHousing' //用房信息
import OrderQuotation from './Components/OrderQuotation' //酒店报价列表
import OrderHotelQuotation from './Components/OrderHotelQuotation' //酒店报价列表
import OrderHotelFill from './Components/OrderHotelFill' //酒店报价列表
import OrderHoteRefuse from './Components/OrderHoteRefuse' //酒店报价列表
import OrderCheckList from './Components/OrderCheckList' //核房人、支付人、入住名单
import Orderbutton from './Components/Orderbutton/index' //订单按钮组件
import OrderCollectionOnDehalf from './Components/OrderCollectionOnDehalf' //代收款弹窗 
import OrderFlagMarker from './Components/OrderFlagMarker' //标注信息旗
import OrderConfirmPanel from './Components/OrderConfirmPanel' //查看修改弹窗
export default {
  name: 'OrderIndex',
  components: {
    OrderState,
    OrderTeam,
    OrderHousing,
    OrderQuotation,
    OrderHotelQuotation,
    OrderHotelFill,
    OrderHoteRefuse,
    OrderCheckList,
    Orderbutton,
    OrderCollectionOnDehalf,
    OrderFlagMarker,
    OrderConfirmPanel,
  },
  props: {
    orderId: {              //订单ID
      type: String,
      required: true
    }
  },
  data() {
    return {
      orderDetail: {
        room_need_arr:[],
        meeting_need_arr:[],
      },                 //订单详情
      quotationList: {},                               //询价状态·酒店报价列表
      clockCount:'',                  //询价倒计时
      collectionShow:false,           //代收款弹窗
      /*************************酒店信息**************************/ 
      my_offer: {},                   //酒店已报价列表
      match_hotel_list:[],            //酒店未报价列表
      quotationShow: false,           //酒店报价弹窗
      refuseShow:false ,              //接不了弹窗
      hotel_id: '',                  //报价酒店ID
      /*订单取消弹窗*/
      showConfirmPanel: false,       //订单取消弹窗
      showShopCar:false,             //订单取消验证码弹窗
      arrow_down: '',                //订单原因
      options: [{
        value: '1',
        label: '团队未成行'
        }, {
        value: '2',
        label: '团队选择其他酒店'
        }, {
        value: '3',
        label: '信息填写错误'
        },
      ],
      confirmPanelShow:false,             //查看修改弹窗
    }
  },
  computed: {
     ...mapGetters(['storeInfo','isGroup']),
     //酒店报价时选择订单进入的报价的酒店ID
     match_store_id () { return this.$route.query.match_store_id},
    //修改成功返回订单详情-给出提示框
     modify () { return this.$route.query.modify},
  },
  watch: {},
  created() {},
  mounted() {
    this.getorderDetail();
    if(this.modify){
      this._alert(this.modify==1?'订单修改成功，等待对方确认':'等待确认期间不允许修改',()=>{
          // 复制原有query，单独修改modify
          const newQuery = {
            orderId:this.orderId,
          }
          this.$router.replace({
            path: this.$route.path,
            query: newQuery
          })
      },null,'error');
    }
  },
  methods: {
    ...mapActions(['POST_OrderHotelDetail','cancellationOfOrder']),
    //获取订单详情
    getorderDetail(){
      this.POST_OrderHotelDetail(this.orderId).then(res => {
        //订单详情
        this.orderDetail={
          ...this.orderDetail,
          ...res.info,
          need_mode:res.info.room_need_arr.mode,
          room_need_arr:res.info.room_need_arr,
          meeting_need_arr:res.info.meeting_need_arr,
        };
        //成交订单状态·前台电话-提供早餐
        if(res.info.deal_time>0){
          this.orderDetail.hotel_tel=res.select_hotel.hotel_tel;
          this.orderDetail.hotel_breakfast_type=res.select_hotel.breakfast_type;
        }
        //************供应商订单************-->
        //报价状态
        if(this.storeInfo.type==2&&res.info.status==4){
            this.my_offer=res.my_offer;
            this.quotationList={
              ...res.offer,
              list:res.offer.list.map(item=>{
                return {
                  ...item,
                  room_offer_arr:this.getList(item.room_offer_arr),
                  meeting_offer_arr:this.getList(item.meeting_offer_arr),
                };
              }) 
            };
            this.setClockCount();
        }
        //酒店销售且在报价的状态
        if(this.storeInfo.type==3&&res.info.status==4){
          this.initHotelData(res);
        }
      })
    },
    //酒店销售初始化数据
    initHotelData(res){
        //默认未报价添加报价值
        //初始化默认都有初始房型跟报价列表ID门店名称一致
        res.match_hotel_list.forEach(item=>{
            item.oid=this.orderDetail.oid;                      //订单ID
            item.store_id=item.match_store_id;                  //酒店ID
            item.offer_store_id=item.match_store_id;
            item.room_offer_arr=res.info.room_need_arr;
            item.meeting_offer_arr=res.info.meeting_need_arr;
            item.whetherQuote=false;                          //是否报价标识-未报价
            item.offer_type='';                             //报价状态-未报价
        });
        res.my_offer.list.forEach(item=>{
            item.whetherQuote=true;                           //是否报价标识-已报价
        });
        //报价列表跟未报价列表相同ID合并
        let roomStyle=this.$_Array.mergeArrById(res.match_hotel_list,res.my_offer.list,'offer_store_id');
        
        //询价状态·已酒店报价列表
        this.quotationList={
          ...res.my_offer,
          list:res.my_offer.list.map(item=>{
            return {
              ...item,
              room_offer_arr:this.getList(item.room_offer_arr),
              meeting_offer_arr:this.getList(item.meeting_offer_arr),
            };
          }) 
        };
        //询价状态·未酒店未报价列表
        this.match_hotel_list=roomStyle;
    },
    //封装取值函数
    getList(obj) {
      if (!obj || !obj.list) return [];
      return obj.list
    },
    //开启酒店报价弹窗
    onquotationShow(e){
      this.quotationShow=true;
      this.$refs.OrderHotelFill.betterOfferHotel(e.store_id)
    },
    //开启酒店接不了弹窗
    onrefuseShow(e){
      this.refuseShow=true;
      this.$refs.OrderHoteRefuse.betterOfferHotel(e.store_id)
    },
    //开启修改弹窗
    onViewChanges(){
      this.confirmPanelShow=true;
      this.$refs.confirmPanel.POST_OrderHotelDetail(this.orderDetail.oid);
    },
    /*计算订单有效期倒计时*/
    setClockCount () {
        this._timer = setInterval(() => {
          let timeDiff = this.$GFUN.getTimeDiff(this.orderDetail.date_in*1)
          this.clockCount = '剩' + timeDiff + '自动取消'
          if (timeDiff === '订单过期已失效') {
            this.clockCount = '订单超时，已自动取消';
            clearInterval(this._timer);
          }
        }, 1000)
    },
    /*弹出短信验证框*/
    number(){
          if(this.arrow_down==''){
                this._alert('请选择取消原因', null, 'error');
          }else{
            this.showConfirmPanel=!this.showConfirmPanel;
            this.cancel_type=this.arrow_down;
            this.arrow_down=''
              //如果订单成交弹出短信验证框，否则直接取消订单
            if(this.orderDetail.deal_time>0){
                this.showShopCar=!this.showShopCar;
            }else{
                this.submitOrder();
            }
          }
        
    },
    /*取消订单*/
    submitOrder(e) {
        this.cancellationOfOrder({
            oid:this.orderDetail.oid,
            cancel_type:this.cancel_type,
            sms_code:e,
                successFun: () => {
                    this.getorderDetail();
                    this.showShopCar = false;
                    this._alert('取消订单成功');
                }
        });
    },
  }
};
</script>

<style lang="scss" scoped>
*{
  text-align: left;
}
.OrderIndex{
  width: 100%;
  min-width: 1200px;
  margin: 0 auto;
  // position: relative; 
}
.order-detail{
  display: flex;
}
.order-detail-title{
  font-weight: bold;
  font-size: 24px;
  color: #333;
}
.order-detail-content{
  margin-left: 20px;
  margin-top: 12px;
}
.housing{
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 20px;
}
.order-detail-end{
  margin-left: auto;
  display: flex;
  line-height: 35px;
}
.check{
  display: flex;
  justify-content: space-between;
}
.selects{
  margin: 0 auto;
  width: 100%;
}
.cancel{
  display: flex;
  justify-content: flex-end;
  margin-top: -10px;
}
</style>
<style>
  .OrderIndex .el-dialog__header{
    padding: 0;
    margin-bottom: 0;
  }
</style>